import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useGetCertificadoEmpresaItByUser = () => {
  const [loadingGetCertificadoEmpresaItByUser, setLoadingGetCertificadoEmpresaItByUser] = useState(false);
  const [successGetCertificadoEmpresaItByUser, setSuccessGetCertificadoEmpresaItByUser] = useState(false);
  const [errorGetCertificadoEmpresaItByUser, setErrorGetCertificadoEmpresaItByUser] = useState(null);
  const [dataGetCertificadoEmpresaItByUser, setDataCertificadoEmpresaItByUser] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )

  
  //GET
  const getCertificadoEmpresaItByUser = async (userId: string, expedienteId: string, _cb?:(data:any)=>void) => {
    setLoadingGetCertificadoEmpresaItByUser(true);
    setSuccessGetCertificadoEmpresaItByUser(false);
    setErrorGetCertificadoEmpresaItByUser(null);

    apirecord.getCertificadoEmpresaItByUser(userId, expedienteId).then((res: any) => {
      setLoadingGetCertificadoEmpresaItByUser(false);
      setSuccessGetCertificadoEmpresaItByUser(true);
      setDataCertificadoEmpresaItByUser(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingGetCertificadoEmpresaItByUser(false);
      setErrorGetCertificadoEmpresaItByUser(err)
    })
  }


  return {
    getCertificadoEmpresaItByUser,
    loadingGetCertificadoEmpresaItByUser,
    successGetCertificadoEmpresaItByUser,
    errorGetCertificadoEmpresaItByUser,
    dataGetCertificadoEmpresaItByUser
  }

}

export default useGetCertificadoEmpresaItByUser;